import { useMemo, useState } from "react";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import { Button, Skeleton, Table, TableBody, TableCell } from "@mui/material";
import { useMutation, useQuery } from "react-query";
import CustomPagination from "../../shared/CustomPagination";
import { deleteFn, getFn } from "../../Services/sharedGeneralFn";
import { API_URLS } from "../../config/apiUrls";
import SearchAndSelect from "../../shared/SearchAndSelect";
import { DeleteForever, Edit } from "@mui/icons-material";
import ConfirmationDialog from "../../shared/ConfirmationDialog";
import { toast } from "react-toastify";
import AddNewVariantTypeThree from "./AddNewVariantTypeThree";
import {
  deleteTypeFour,
  getTypeFour,
  getTypeFourCategory,
} from "../../Services/VariantTypeFour";

const VariantOtherTypeFour = () => {
  const [typeId, setTypeId] = useState();
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [editVariant, setEditVariant] = useState();
  const navigate = useNavigate();

  const {
    data: otherTypeDataDirty,
    isLoading,
    refetch,
  } = useQuery(["connectivityTypeData", page, searchQuery, typeId], () =>
    getTypeFour({ page, search: searchQuery, variant: typeId }),
  );

  const otherTypeData = useMemo(
    () => otherTypeDataDirty?.data?.data,
    [otherTypeDataDirty?.data?.data],
  );

  const { data: typeTwoCategories } = useQuery(
    ["typefourCategories"],
    () => getTypeFourCategory(),
    {
      select: (data) =>
        data?.data?.data.map((item) => {
          return {
            label: `${item.title} (${item.category_name})`,
            value: item.id,
          };
        }) || [],
    },
  );

  const { mutate: deleteStorageVariant } = useMutation(
    (id) =>
      deleteTypeFour({
        variant_value_ids: [id],
      }),
    {
      onSuccess: (res) => {
        if (res.data.response_code === 200) {
          toast.success(res.data.message);
          refetch();
        } else {
          toast.error(res.data.message);
        }
      },
    },
  );

  const handleDelete = (id) => {
    deleteStorageVariant(id);
  };

  return (
    <>
      <div className="bg-slate-100">
        <div className="flex justify-between bg-slate-100">
          <div className="p-2">
            <p className="text-xl font-bold text-black font">
              Other variant Value (Type Four)
            </p>
          </div>
          <div className="float-left m-1">
            <button
              onClick={() =>
                navigate(
                  "/variant-management-connectivity/manage-connectvity-varient",
                )
              }
              className="px-3 py-1 text-lg text-black bg-white rounded-lg"
              style={{ border: "1px solid black" }}
            >
              <VisibilityIcon /> Type Four
            </button>
          </div>
        </div>

        <div className="flex flex-col !my-3 !rounded  bg-dark bg-slate-100 shadow-card shadow-zinc-600 m-2">
          <div className="flex items-center justify-between p-2 h-14 border-zinc-600">
            <div className="flex">
              <input
                type="text"
                className="!border-3 !border-black !w-72 px-2 rounded-md py-1"
                placeholder="search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ border: "1px solid black" }}
              />
            </div>
            <div className="flex flex-row gap-4">
              <AddNewVariantTypeThree
                editVariantData={editVariant}
                setEditVariantData={setEditVariant}
              />
              <SearchAndSelect
                className="!w-80"
                options={typeTwoCategories}
                placeholder="Select Type"
                value={typeId}
                setValue={setTypeId}
              />
            </div>
          </div>

          <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  {["ID", "VALUE", "TYPE THREE", "CATEGORIES", "ACTIONS"].map(
                    (header, index) => (
                      <TableCell
                        key={index}
                        align="center"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                        className="!text-center !text-gray-800 !font-bold"
                      >
                        {header}
                      </TableCell>
                    ),
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading
                  ? Array.from({ length: 5 }).map((_, index) => (
                      <TableRow key={index}>
                        {Array.from({ length: 5 }).map((_, idx) => (
                          <TableCell key={`${idx}-${index}`}>
                            <Skeleton />
                          </TableCell>
                        ))}
                      </TableRow>
                    ))
                  : null}
                {otherTypeData &&
                  otherTypeData.map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.id}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.value}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.variant_name}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.category_name}
                      </TableCell>
                      <TableCell
                        className="flex flex-row gap-2 !text-center !text-[12px]"
                        style={{
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        <Button
                          className="!min-w-fit"
                          onClick={() => setEditVariant(row)}
                        >
                          <Edit className="text-green-500 cursor-pointer" />
                        </Button>
                        <ConfirmationDialog
                          title="Are you sure you want to delete this variant?"
                          description="This will permanently remove the selected variant from the database."
                          onConfirm={() => handleDelete(row?.id)}
                        >
                          <DeleteForever className="text-red-500 cursor-pointer" />
                        </ConfirmationDialog>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <CustomPagination data={otherTypeDataDirty} setPage={setPage} />
        </div>
      </div>
    </>
  );
};

export default VariantOtherTypeFour;
